import request from '@/utils/request'

/**
 * 已停机列表
 * @param {*} params token,userId
 * @returns
 */
export const Equipment = params => {
  return request({
    method: 'post',
    url: '/cm/eqp/mobileList',
    data: params
  })
}

/**
 * 已停机列表
 * @param {*} params token,userId
 * @returns
 */
export const EquipmentBeyond = params => {
  return request({
    method: 'post',
    url: '/cm/eqp/mobileOverFlowList',
    data: params
  })
}
